import {CartItemData} from 'components/common/CartItemData'
import {Frame} from 'components/system/Frame'
import {Exp1, Ventrata} from 'types'
import {formatAvailabilityId} from 'utils/formatAvailabilityId'

type Props = {
  booking: Ventrata.Booking
  exp1Product: Exp1.Product | null
}

export const CartItem = ({booking, exp1Product}: Props) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="text-french-blue-030 text-lg font-bold">
        {formatAvailabilityId(booking.availabilityId, 'dddd, MMM DD')}
      </div>
      <Frame className="flex gap-4 w-full relative">
        <CartItemData booking={booking} exp1Product={exp1Product} />
      </Frame>
    </div>
  )
}
